module.exports = __webpack_public_path__ + "img/powered-unifrutti.1ea2ac15.svg";